<template lang="html">
    <div id="admin-dashboard">
        <h2>Admin Panel</h2>
        <div class="form-container">
            <label for="account">Account：</label>
            <input type="text" name="account" id="account" v-model="account">
        </div>
        <br>
        <div class="form-container">
            <label for="password">Password:</label>
            <input type="password" name="password" id="password" v-model="password">
        </div>

        <div class="col span-2-of-3">
            <a
                href="#"
                class="btn btn-full"
                @click.prevent="">Login</a>
        </div>
    </div>
</template>

<script>
import { auth } from '../../store/firebase.js';
// hard coded for admin password
import { admin_account } from '../../data/admin_account'

export default {
    data() {
        return {
            account : '',
            password: ''
        }
    },
    methods: {
        login() {
            if(this.account === admin_account.account && this.password === admin_account.password) {
                    
            } else {
                alert('The account / password is wrong!');
            }
        }
    }
}
</script>

<style lang="scss">
#admin-dashboard {
    width: 100%;
}

.form-container {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}

</style>



// WEBPACK FOOTER //
// Dashboard.vue?a971bad2